/*
import {
  hf,
  hfDTM,
  hfXLS,
  ht,
  gs,
  cmPDF,
} from 'lib';
*/
import * as cmPDF from "./_cmPDF";
import * as ht from './_ht';
import * as hf from './_hf';
import * as hfDTM from './_hfDTM';

import * as ihd from './ihd';
import * as icv from './icv';
import * as icvI18___Mz from './icvI18___Mz';

export const eptPdfAsync = async (pz: { // 方式１：団体番号＋メールアドレス＋パスワード
  i18r_fst: ht.n,
}) => {

  const _i18z = await icvI18___Mz.loadI18rDzAsync({
    i18r_fst: pz.i18r_fst,
  });
  const _i18rz = _i18z.i18rz;

  let _fileName = `初回ご登録の手引き_${_i18rz.i18rab100s}_${hfDTM.f(hfDTM.getTdy(), 'YYYYMMDD')}.pdf`;

  let _lines = [] as ht.ls;

  let _row = 0;
  _lines.push({ type: 'text', pfx: `初回ご登録の手引き`,  cmn: 1, row: _row, cmnCnt: 54, rowCnt: 2, ta: 'ctr', frm: false, ts: 1.2, tb: true });

  _row = 3;
  _lines.push({ type: 'text', pfx: `１．パソコン、もしくはスマートフォンより、下記の初期設定画面を開いてください。`,  cmn: 1, row: _row, rowCnt: 1 });

  const _id = hf.cvtNbr('e', pz.i18r_fst, icv.srtz.nbrz1);
  const _url = `${icv.appz.urlw}/set?id=${_id}`;

  _row += 1;
  _row += 1;
  _lines.push({ type: 'text', pfx: `【URL】　${_url}`,  cmn: 3, row: _row, rowCnt: 1.5, cmnCnt: 50, ta: 'ctr', frm: true});

  _row += 1.5;
  _lines.push({ type: 'text', pfx: `▼QRコードからページを開ける方は以下をご利用いただけます`,  cmn: 3, row: _row, rowCnt: 1.5, cmnCnt: 50, ta: 'ctr', frm: false});
  _lines.push({ type: 'text', pfx: ``,  cmn: 3, row: _row, rowCnt: 7, cmnCnt: 50, ta: 'ctr', frm: true});
  _row += 1.0;
  _lines.push({ type: 'qcd', pfx: _url, cmn: 23, row: _row, rowCnt: 7});
  _row += 6;

  _row += 1;
  _row += 1;
  _lines.push({ type: 'text', pfx: `２．初期設定画面において、下記の初期設定用確認コードを入力した後、[送る]ボタンを`,  cmn: 1, row: _row, rowCnt: 1, });
  _row += 1;
  _lines.push({ type: 'text', pfx: `　　押し、初回登録画面を表示してください。`,  cmn: 1, row: _row, rowCnt: 1, });

  const _pwd = hf.cvtNbr('e', pz.i18r_fst, icv.srtz.nbrz2);

  _row += 1;
  _row += 1;
  _lines.push({ type: 'text', pfx: `団体番号`,  cmn: 3, row: _row, rowCnt: 1.5, cmnCnt: 18, ta: 'ctr', frm: true});
  _lines.push({ type: 'text', pfx: `${_i18rz.i18rab100s}`,  cmn: 21, row: _row, rowCnt: 1.5, cmnCnt: 32, ta: 'ctr', frm: true});
  _row += 1.5;
  _lines.push({ type: 'text', pfx: `団体名`,  cmn: 3, row: _row, rowCnt: 1.5, cmnCnt: 18, ta: 'ctr', frm: true});
  _lines.push({ type: 'text', pfx: `${_i18rz._pfx.substring(0,20)}`,  cmn: 21, row: _row, rowCnt: 1.5, cmnCnt: 32, ta: 'ctr', frm: true});
  _row += 1.5;
  _lines.push({ type: 'text', pfx: `初回登録用確認コード`,  cmn: 3, row: _row, rowCnt: 1.5, cmnCnt: 18, ta: 'ctr', frm: true});
  _lines.push({ type: 'text', pfx: `${_pwd}`,  cmn: 21, row: _row, rowCnt: 1.5, cmnCnt: 32, ta: 'ctr', frm: true, });

 _row += 1;

  _row += 1;
  _row += 1;
  _lines.push({ type: 'text', pfx: `３．初回登録画面において、メールアドレスを登録してください。`,  cmn: 1, row: _row, rowCnt: 1, });
  _row += 1;

  _row += 1;

  _lines.push({ type: 'text', pfx: `　　設定したメールアドレスは、「設定画面」からいつでも変更出来ます。`,  cmn: 1, row: _row, rowCnt: 1, });
  _row += 1;

  _row += 1;

  _lines.push({ type: 'text', pfx: `　　正常にメールアドレスの登録が完了すると、「メールアドレス登録のご連絡」`,  cmn: 1, row: _row, rowCnt: 1, });
  _row += 1;
  _lines.push({ type: 'text', pfx: `　　というタイトルの確認メールが５分以内に自動で届きます。`,  cmn: 1, row: _row, rowCnt: 1, });
  _row += 1;

  _row += 1;

  _lines.push({ type: 'text', pfx: `　　※ 上記のメールが届かない場合は、正常に登録されていない可能性がございます。`,  cmn: 1, row: _row, rowCnt: 1, });
  _row += 1;
  _lines.push({ type: 'text', pfx: `　　　その場合は、もう一度最初からお試しください。`,  cmn: 1, row: _row, rowCnt: 1, });
  _row += 1;

  _row += 1;
  _lines.push({ type: 'text', pfx: `　　【ご注意】`,  cmn: 1, row: _row, rowCnt: 1, });
  _row += 1;
  _lines.push({ type: 'text', pfx: `　　・メールが届かない場合、迷惑メール防止サービスをご利用されているお客様は、`,  cmn: 1, row: _row, rowCnt: 1, });
  _row += 1;
  _lines.push({ type: 'text', pfx: `　　　迷惑メールとして判定されていないかのご確認をお願いします。`,  cmn: 1, row: _row, rowCnt: 1, });
  _row += 1;
  _lines.push({ type: 'text', pfx: `　　・PCからのメールを拒否されており、ドメイン単位での受信許可が可能な方は、`,  cmn: 1, row: _row, rowCnt: 1, });
  _row += 1;
  _lines.push({ type: 'text', pfx: `　　　「${icv.dmn}」`,  cmn: 1, row: _row, rowCnt: 1, });
  _row += 1;
  _lines.push({ type: 'text', pfx: `　　　から届くメールの受信許可設定をお願いいたします。`,  cmn: 1, row: _row, rowCnt: 1, });

  _row += 1;
  _row += 1;
  _lines.push({ type: 'text', pfx: `　　※ 何度試してもうまくメールが登録されない場合は、お手数ですが、窓口まで`,  cmn: 1, row: _row, rowCnt: 1, });
  _row += 1;
  _lines.push({ type: 'text', pfx: `　　　ご相談ください。`,  cmn: 1, row: _row, rowCnt: 1, });

  _row += 1;
  _row += 1;
  _row += 1;
  _lines.push({ type: 'text', pfx: `【この用紙は、メール登録完了後、処分して頂いて問題ありません】`,  cmn: 1, row: _row, rowCnt: 1, cmnCnt: 54, ta: 'ctr'});

  _lines.push({ type: 'pstCvsToPdf' });
  _lines.push({ type: 'savePdf' });

  cmPDF.dldFileAsync({
    fileName: _fileName,
    lines: _lines,
    itlz: {
      orientation: 'portrait',
    },
  })
};
